var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelligence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    enableBackground: "new 0 0 85 85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M22.355,21.169c-2.105,1.208-3.928,3.824-2.515,9.477c0,0-11.5,10-1,20.249c0,0-3,13.5,8.5,14.25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M35.439,28.398 c-4.488,0-8.125-3.639-8.125-8.125c0-4.488,3.638-8.125,8.125-8.125c4.486,0,8.124,3.637,8.124,8.125v45.196 c0,2.719-1.428,4.998-3.862,6.459c-3.785,2.275-8.697,1.049-10.97-2.734c-1.869-3.107-1.376-6.979,0.956-9.521l4.543-4.943"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M42.23,15.83 c0.83,1.164,1.109,2.463,0.498,3.732c-0.121,0.252-0.275,0.5-0.463,0.738c-1.357,1.725-3.877,2.025-5.604,0.668"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M30.178,36.033 c-2.271-0.559-3.673-2.871-3.115-5.141c0.558-2.271,2.872-3.67,5.144-3.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M43.365,39.033 c-1.75-1.549-4.729-1.5-6.28,0.252c0,0-6.522,9.776-11.356,9.776"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 26.688,
    y1: 56.27,
    x2: 31.208,
    y2: 57.781
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M23.812,40.646 c0,0,4.25,2,7.25,5.249"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 66.328,
    cy: 56.676,
    r: 4.252
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 43.867,49.008 49.609,49.008 57.275,56.676 62.021,56.676  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 43.867,59.104 49.609,59.104 56.459,65.875  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 59.412,
    cy: 68.906,
    r: 4.252
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 66.328,
    cy: 28.324,
    r: 4.252
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "43.867,35.99  49.609,35.99 57.275,28.324 62.076,28.324  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 43.867,25.894 49.609,25.894 56.387,19.117  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 59.412,
    cy: 16.093,
    r: 4.252
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 43.764,
    y1: 42.499,
    x2: 54.334,
    y2: 42.499
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 58.523,
    cy: 42.5,
    r: 4.252
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M37.808,63.93 c0.805-1.49,2.676-2.051,4.165-1.248c1.066,0.574,1.629,1.701,1.582,2.84"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligence);
export default __webpack_public_path__ + "static/media/intelligence.191362ff40dcfcd09abd264093b9c977.svg";
export { ForwardRef as ReactComponent };